module.exports = __webpack_public_path__ + "media/images/social_icons/facebook-6bdd6f21086465ebca59551fc7041072.png";